import template from './salesman.html';
import controller from './salesman.controller';

let salesmanComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default salesmanComponent;
